export default __webpack_public_path__ + "static/dwilinski-64992a66ef27ca8bb312b678ce6cf125.jpg";